import classNames from "classnames";

import CheckboxGroup from "@/migrated-widgets/table-map/components/molecules/CheckboxGroup";
import { CheckboxGroupItem } from "@/migrated-widgets/table-map/components/molecules/CheckboxGroup/Item";
import { CheckboxIcon } from "@/migrated-widgets/table-map/components/icons/CheckboxIcon";
import { useTableMapState } from "./TableMapState";

export const FilterByCrmLeads: React.FC<{}> = () => {
  const { showCrmLeads, setShowCrmLeads } = useTableMapState();

  return (
    <CheckboxGroup checkboxes={{ className: "gap-6", width: "w-full" }}>
      <CheckboxGroupItem
        onClick={() => setShowCrmLeads((prev) => !prev)}
        className={classNames("text-sm text-left text-table-map-black")}
        onHoverClass=""
      >
        <div className="flex items-center gap-1">
          <div
            className={classNames(
              "w-4 h-4 rounded-[3px]",
              "bg-gray-100 border border-table-map-lightGray",
              { "!bg-[#35434a] border-0": showCrmLeads },
            )}
          >
            {showCrmLeads && <CheckboxIcon />}
          </div>
          <span className="text-nowrap">CRM Leads</span>
        </div>
      </CheckboxGroupItem>
    </CheckboxGroup>
  );
};
